import { Modal } from "antd";
import { DsaUploadFolderDto } from "../../generated/dashboard-client";
import "../../components/design/MoveToFolderModal.scss";
import { DsaFolderThumb } from "./DsaFolderButton";
import { DsaMoveToFolderMenuContent } from "./DsaMoveToFolderMenuContent";

export interface DsaMoveToFolderModalProps {
  isVisible: boolean;
  uploadIds: string[];
  folders: DsaUploadFolderDto[];
  activeFolder: DsaUploadFolderDto | null;
  onCloseMovedToFolder: (save: boolean, folder?: DsaUploadFolderDto) => void;
  onCloseMovedToUploads: (uploadIds: string[]) => void;
  onCloseMovedFolderToFolder: (childFolderId: number, parentFolderId: string) => void;
  folderToMove: DsaUploadFolderDto | null;
  folderThumbs: DsaFolderThumb[];
  folderNameExists: (folder: DsaUploadFolderDto | null, name: string) => boolean | undefined;
  onCreateFolderModalClose: (uploadIds: string[], folderToMove?: DsaUploadFolderDto | null, folder?: DsaUploadFolderDto) => void;
}

export function DsaMoveToFolderModal({
  isVisible,
  uploadIds,
  folders,
  activeFolder,
  onCloseMovedToFolder,
  onCloseMovedToUploads,
  onCloseMovedFolderToFolder,
  onCreateFolderModalClose,
  folderToMove,
  folderThumbs,
  folderNameExists
}: DsaMoveToFolderModalProps) {
  return (
    <Modal
      className={"clean one add-design-to-folder"}
      visible={isVisible}
      onCancel={() => onCloseMovedToFolder(false)}
    >
      <DsaMoveToFolderMenuContent
        uploadIds={uploadIds}
        folders={folders}
        activeFolder={activeFolder}
        onCloseMovedToFolder={onCloseMovedToFolder}
        onCloseMovedToUploads={onCloseMovedToUploads}
        onCloseMovedFolderToFolder={onCloseMovedFolderToFolder}
        folderToMove={folderToMove}
        folderThumbs={folderThumbs}
        folderNameExists={folderNameExists}
        onCreateFolderModalClose={onCreateFolderModalClose}
        onBack={() => { return; }}
        isMobile={false}
      />
    </Modal>
  );
}
